<template>
    <section id="dashboard" v-loading="loading">
        <el-row
            :gutter="10"
            type="flex"
            justify="space-between"
            style="width: 100%"
        >
            <el-button link type="primary" size="small" @click="addRow"
                >Add new</el-button
            >
        </el-row>
        <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :default-sort="{ prop: 'order_num', order: 'ascending' }"
        >
            <el-table-column fixed prop="path" label="Path" :min-width="20">
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.path"
                        :disabled="!scope.row.edit"
                        placeholder="ex:: https://awardapplication.com/image.jpg"
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="order_num" label="Order" :min-width="4">
                <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.order_num"
                        placeholder="Select"
                        size="small"
                        :disabled="!scope.row.edit"
                    >
                        <el-option
                            v-for="item in order_arr"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                        />
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="desc" label="Description" :min-width="60">
                <template slot-scope="scope">
                    <el-input
                        class="desc"
                        type="textarea"
                        autosize
                        placeholder="ex:: Closing Deadlines for Award"
                        v-model="scope.row.desc"
                        :disabled="!scope.row.edit"
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="color" label="Color" :min-width="4">
                <template slot-scope="scope">
                    <el-color-picker
                        :disabled="!scope.row.edit"
                        v-model="scope.row.color"
                    />
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="Operations" :min-width="12">
                <template slot-scope="{ row, $index }">
                    <template v-if="row.edit">
                        <el-button
                            link
                            type="success"
                            size="small"
                            @click="saveRow(row, $index)"
                        >
                            Save
                        </el-button>
                        <el-button
                            link
                            type="info"
                            size="small"
                            @click="cancelEdit(row, $index)"
                        >
                            Cancel
                        </el-button>
                    </template>
                    <template v-else>
                        <el-button
                            link
                            type="primary"
                            size="small"
                            @click="row.edit = true"
                        >
                            Edit
                        </el-button>
                    </template>
                    <el-button
                        link
                        type="danger"
                        size="small"
                        @click="deleteRow(row, $index)"
                    >
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </section>
</template>

<script>
import adminApi from "../api";

export default {
    name: "LandingConfig",
    data() {
        return {
            loading: false,
            order_arr: [],
            tableData: [],
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        addRow() {
            let newRow = {
                id: null,
                path: "",
                order_num: this.tableData.length + 1,
                desc: "",
                color: "",
                edit: true,
                isNew: true,
            };
            this.tableData = [newRow, ...this.tableData];
            this.rebuildOrderOptions();
        },

        async saveRow(row) {
            if (!row.path || !row.desc || !row.color) {
                this.$message.error("Please fill in all fields.");
                return;
            }

            this.loading = true;
            const data = {
                path: row.path,
                order_num: row.order_num,
                desc: row.desc,
                color: row.color,
            };

            try {
                if (row.isNew) {
                    const res = await adminApi.createConfig(data);
                    row.id = res.data.slide.id;
                    row.isNew = false;
                } else {
                    await adminApi.updateConfig(row.id, data);
                }
                row.edit = false;
                this.$message.success("Saved successfully.");
            } catch (err) {
                this.$message.error("Failed to save.");
            } finally {
                this.loading = false;
            }
        },

        cancelEdit(row, index) {
            if (row.isNew) {
                this.tableData.splice(index, 1);
                this.rebuildOrderOptions();
            } else {
                row.edit = false;
                this.loadData();
            }
        },

        async deleteRow(row, index) {
            if (row.isNew) {
                this.tableData.splice(index, 1);
                this.rebuildOrderOptions();
                return;
            }

            try {
                await this.$confirm(
                    "Are you sure you want to delete this slide?",
                    "Warning",
                    { type: "warning" }
                );
            } catch {
                return;
            }

            this.loading = true;
            try {
                await adminApi.deleteConfig(row.id);
                this.tableData.splice(index, 1);
                this.rebuildOrderOptions();
                this.$message.success("Deleted successfully.");
            } catch (err) {
                this.$message.error("Failed to delete.");
            } finally {
                this.loading = false;
            }
        },

        rebuildOrderOptions() {
            this.order_arr = this.tableData.map((_, i) => ({
                value: i + 1,
                label: i + 1,
            }));
        },

        loadData() {
            this.loading = true;
            adminApi
                .getLandingSlides()
                .then((r) => {
                    const items = r.data.slides;
                    this.tableData = items.map((item) => ({
                        id: item.id,
                        path: item.path,
                        order_num: item.order_num,
                        desc: item.desc,
                        color: item.color,
                        edit: false,
                        isNew: false,
                    }));
                    this.rebuildOrderOptions();
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style>
.desc textarea {
    resize: none;
}
</style>
